import { Modal, ModalProps, Space, Text, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as DocumentWithBankIcon } from '../../../../../assets/images/lending/document-with-bank.svg'
import { ReactComponent as DocumentsIcon } from '../../../../../assets/images/lending/documents.svg'
import { ReactComponent as UserIcon } from '../../../../../assets/images/lending/user.svg'
import { useEmberRouter } from '../../../../../contexts/emberRouterContext'
import { EmberRoute } from '../../../../../enums/emberRoute'
import { useFrodaFinanceLendingContext } from '../../contexts/frodaFinanceLendingContext'
import { EligibilityRequirementRow } from './elements'

export const FrodaLendingEligibilityModal = (props: ModalProps): ReactElement => {
  const { t } = useTranslation()
  const { navigate } = useEmberRouter()
  const { close: closeModal } = useModal(props.id)
  const { eligibilityRequirements } = useFrodaFinanceLendingContext()

  const shouldConnectBank = !eligibilityRequirements.hasConnectedBank
  const shouldCompleteProfileDetails = !eligibilityRequirements.isUserDataComplete
  const shouldAddRegistrationNumber = !eligibilityRequirements.hasRegistrationNo

  const handleConnectBankLinkClick = useCallback(() => {
    closeModal()
    navigate(EmberRoute.BankAccounts)
  }, [navigate, closeModal])

  const handleProfileDetailsClick = useCallback(() => {
    closeModal()
    navigate(EmberRoute.SettingsUser)
  }, [navigate, closeModal])

  const handleRegistrationNumberClick = useCallback(() => {
    closeModal()
    navigate(EmberRoute.SettingsOrganization)
  }, [navigate, closeModal])

  return (
    <Modal closable {...props} size="s">
      <Modal.Header title={t('financing.froda_lending.eligibility_modal.title')} />
      <Modal.Body>
        <Text>{t('financing.froda_lending.eligibility_modal.description')}</Text>
        <Space size="s24" />
        {shouldConnectBank && (
          <EligibilityRequirementRow
            title={t('financing.froda_lending.eligibility_modal.criteria.connect_bank')}
            icon={<DocumentsIcon />}
            onClick={handleConnectBankLinkClick}
          />
        )}
        {shouldCompleteProfileDetails && (
          <EligibilityRequirementRow
            title={t('financing.froda_lending.eligibility_modal.criteria.profile_details')}
            icon={<UserIcon />}
            onClick={handleProfileDetailsClick}
          />
        )}
        {shouldAddRegistrationNumber && (
          <EligibilityRequirementRow
            title={t('financing.froda_lending.eligibility_modal.criteria.registration_number')}
            icon={<DocumentWithBankIcon />}
            onClick={handleRegistrationNumberClick}
          />
        )}
      </Modal.Body>
    </Modal>
  )
}
